const i18n = {
  DE: {
    nav: {
      umzug: "Umzug",
      reinigung: "Reinigung",
      montage: "Montage",
      logistik: "Logistik",
      offerte: "Offerte",
    },
    footer: {
      impressum: "Impressum",
      datenschutz: "Datenschutz",
    },
    designer: {
      text: "Designed & Developed by",
      tagline: "Professionelle Web-Lösungen",
    },
  },
  EN: {
    nav: {
      umzug: "Moving",
      reinigung: "Cleaning",
      montage: "Assembly",
      logistik: "Logistics",
      offerte: "Quote",
    },
    footer: {
      impressum: "Imprint",
      datenschutz: "Privacy",
    },
    designer: {
      text: "Designed & Developed by",
      tagline: "Professional web solutions",
    },
  },
  SO: {
    nav: {
      umzug: "Guryo guurid",
      reinigung: "Nadiifin",
      montage: "Isku dhejis",
      logistik: "Gaadiid",
      offerte: "Qiime",
    },
    footer: {
      impressum: "Aqoonsi",
      datenschutz: "Xogta gaarka ah",
    },
    designer: {
      text: "Naqshadeeyay & Horumariyay",
      tagline: "Xalal web oo xirfad leh",
    },
  },
};

export default i18n;